import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      redirect: "/notfound",
      component: resolve => require(["@/page/home"], resolve)
    },
    {
      path: "/login",
      name: "login",
      component: resolve => require(["@/page/login"], resolve)
    },
    {
      path: "/resetpwd",
      name: "resetpwd",
      component: resolve => require(["@/page/resetpwd"], resolve)
    },
    {
      path: "/page",
      name: "page",
      component: resolve => require(["@/page/page"], resolve),
      children: [
        {
          path: "download",
          name: "download",
          component: resolve => require(["@/page/download"], resolve)
        },
        {
          path: "downloadList", //分类下载列表
          name: "downloadList",
          component: resolve => require(["@/page/downloadList"], resolve)
        },
        {
          path: "plan",
          name: "plan",
          component: resolve => require(["@/page/plan"], resolve)
        },
        {
          path: "noticelist",
          name: "noticelist",
          component: resolve => require(["@/page/noticelist"], resolve)
        },
        {
          path: "notice",
          name: "notice",
          component: resolve => require(["@/page/notice"], resolve)
        },
        {
          path: "newslist",
          name: "newslist",
          component: resolve => require(["@/page/newslist"], resolve)
        },
        {
          path: "news",
          name: "news",
          component: resolve => require(["@/page/news"], resolve)
        },
        {
          path: "projectintro", //项目介绍
          name: "projectintro",
          component: resolve => require(["@/page/projectintro"], resolve)
        },
        // {
        //   path: 'schedulelist',
        //   name: 'schedulelist',
        //   component: resolve => require(['@/page/schedulelist'], resolve),
        // },
        {
          path: "schedule",
          name: "schedule",
          component: resolve => require(["@/page/schedule"], resolve)
        },
        {
          path: "score", //成绩查询？？？
          name: "score",
          component: resolve => require(["@/page/score"], resolve)
        },
        {
          path: "pics",
          name: "pics",
          component: resolve => require(["@/page/pics"], resolve)
        },
        // {
        //   path: 'register',
        //   name: 'register',
        //   component: resolve => require(['@/page/register'], resolve),
        // },
        {
          path: "startList",
          name: "startList",
          component: resolve => require(["@/page/startlist"], resolve)
        },
        {
          path: "results",
          name: "results",
          component: resolve => require(["@/page/results"], resolve)
        },
        {
          path: "athlete",
          name: "athlete",
          component: resolve => require(["@/page/athlete"], resolve)
        },
        {
          path: "matchconduct", //比赛管理
          name: "matchconduct",
          component: resolve => require(["@/page/matchconduct"], resolve)
          // meta:{
          //   roleId:[1,2,3,4,7],
          // }
        },
        {
          path: "matchadd", //新建比赛
          name: "matchadd",
          component: resolve => require(["@/page/matchadd"], resolve)
          // meta:{
          //   roleId:[1,7],
          // }
        },
        {
          path: "signup", //比赛报名
          name: "signup",
          component: resolve => require(["@/page/signup"], resolve)
          // meta:{
          //   roleId:[1,2,3,4,5,6,7],
          // }
        },
        {
          path: "personalcenter", //个人中心
          name: "personalcenter",
          component: resolve => require(["@/page/personalcenter"], resolve)
        },
        {
          path: "statistics", //比赛统计
          name: "statistics",
          component: resolve => require(["@/page/statistics"], resolve)
          // meta:{
          //   roleId:[1,2,7],
          // }
        },
        {
          path: "picslist", //图集列表
          name: "picslist",
          component: resolve => require(["@/page/picslist"], resolve)
        },
        {
          path: "medaltally", //奖牌榜
          name: "medaltally",
          component: resolve => require(["@/page/medaltally"], resolve)
        }
      ]
    },
    {
      path: "*",
      name: "notfound",
      component: resolve => require(["@/page/notfound"], resolve)
    } //全不匹配的情况下，返回404，路由按顺序从上到下，依次匹配。最后一个*能匹配全部，
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js